import React from 'react';

const UserType = ({title, btnOwner, traveler, btnManager, onClick}) => {
    return (
        <div className="contact__user-type">
            <h3>{title}</h3>
            <button id="frbo" className="btn btn-default" onClick={onClick}>
                {btnOwner}
            </button>
            <button id="pm" className="btn btn-default" onClick={onClick}>
                {btnManager}
            </button>
            <p
                className="contact__traveler-text"
                dangerouslySetInnerHTML={{__html: traveler}}
            />
        </div>
    );
};

export default UserType;
